export const API_BASE_URL = `${process.env.REACT_APP_API_URL_RESSOURCES}/classes`;
export const API_AUTH = `${process.env.REACT_APP_API_URL}`;
export const API_RESSOURCES = `${process.env.REACT_APP_API_URL_RESSOURCES}`;
export const GET_LIST_DATA = (...type: string[]) => `${process.env.REACT_APP_API_URL_RESSOURCES}/users/inscription/static/liste?type=${type}`;